import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { isEmptyString, isNotEmptyString } from '@weft/utils';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import React from 'react';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';

type PaymentOverviewTableDotMenuProps = {
  invoiceId?: string;
  externalInvoiceUrl?: string;
};

export const PaymentOverviewTableDotMenu:React.FC<PaymentOverviewTableDotMenuProps> = ({ invoiceId, externalInvoiceUrl }) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();
  const navigate = useVyNavigate();

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        className='aspect-square rounded-full'
      >
        <span
          className='bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]'
        ></span>
      </IconButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        MenuListProps={{
          className: 'py-0',
        }}
        slotProps={{
          paper: {
            className: 'max-w-[250px] w-full shadow-xl',
          },
        }}
      >
        <MenuItem
          className='pl-2'
          disabled={isEmptyString(externalInvoiceUrl) && isEmptyString(invoiceId)}
          onClick={() => isNotEmptyString(externalInvoiceUrl) ? window.open(externalInvoiceUrl, '_blank') : navigate(`/invoices/overview/light/${invoiceId}`)}
        >
          <Typography>Show Invoice</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};